function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import React from "react";
var arrayShallowEqual = function(a, b) {
    if (a.length !== b.length) {
        return false;
    }
    return a.every(function(error, index) {
        var ref;
        return (error === null || error === void 0 ? void 0 : error.toString()) === ((ref = b[index]) === null || ref === void 0 ? void 0 : ref.toString());
    });
};
export var trustyValidateTransform = function(validate) {
    return function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(value, dependencyValues, validationContext) {
            var ref, timing, existingError, result;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = validationContext !== null && validationContext !== void 0 ? validationContext : {}, timing = ref.timing, existingError = ref.existingError;
                        _ctx.next = 3;
                        return validate(value, dependencyValues, validationContext);
                    case 3:
                        result = _ctx.sent;
                        if (!(timing !== 'change' || result === undefined || Array.isArray(result) && result.length === 0)) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", result);
                    case 6:
                        if (!(Array.isArray(result) && Array.isArray(existingError) && !arrayShallowEqual(result, existingError))) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", result.filter(function(error) {
                            return existingError.includes(error);
                        }));
                    case 8:
                        return _ctx.abrupt("return", existingError);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(value, dependencyValues, validationContext) {
            return _ref.apply(this, arguments);
        };
    }();
};
